import semver from "semver";
import { useWebView } from "@/Tailwind/Mixins/useWebView";

export function mobileSatisfiesVersion(requiredVersion) {
    const { getInfo } = useWebView();

    const version = getInfo().version;
    const semverVersion = semver.valid(semver.coerce(version));

    return semverVersion !== null && semver.gte(semverVersion, requiredVersion);
}
